<template>
  <card class="document">
    <h4 class="d-block d-md-none document__title">{{ title }}</h4>
    <section id="document__header">
      <div class="document__logo">
        <company-logo hide-change-button></company-logo>
      </div>
      <br />
      <div class="document__header">
        <h4 class="d-none d-md-block document__title">{{ title }}</h4>
        <table>
          <tbody>
            <tr v-for="item in headerItems" :key="item.label">
              <td class="document__header__label">{{ item.label }}</td>
              <td class="document__header__value">{{ item.value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <hr />
    <section id="document__personnels">
      <div class="document__personnel">
        <h5 class="document__personnel__label">{{ fromLabel }}</h5>
        <p class="document__personnel__text">{{ from.name }}</p>
        <p class="document__personnel__text">{{ from.address.line1 }}</p>
        <p class="document__personnel__text" v-if="from.address.line2">
          {{ from.address.line2 }}
        </p>
        <p class="document__personnel__text">{{ from.address.district }}</p>
        <p class="document__personnel__text">{{ from.address.region }}</p>
        <p class="document__personnel__text">{{ from.address.country }}</p>
        <p class="document__personnel__text">{{ from.address.postcode }}</p>
        <p class="document__personnel__text" v-if="from.vatNumber">
          VAT #{{ from.address.vatNumber }}
        </p>
      </div>
      <hr />
      <div class="document__personnel">
        <h5 class="document__personnel__label">{{ toLabel }}</h5>
        <p v-if="!to.companyName" class="text-muted">
          {{ $t("message.noCustomerSelected") }}
        </p>
        <template v-else>
          <p class="document__personnel__text">{{ to.companyName }}</p>
          <p class="document__personnel__text">{{ to.address.line1 }}</p>
          <p class="document__personnel__text" v-if="to.address.line2">
            {{ to.address.line2 }}
          </p>
          <p class="document__personnel__text">{{ to.address.district }}</p>
          <p class="document__personnel__text">{{ to.address.region }}</p>
          <p class="document__personnel__text">{{ to.address.country }}</p>
          <p class="document__personnel__text">{{ to.address.postcode }}</p>
          <p class="document__personnel__text" v-if="from.vatNumber">
            VAT #{{ from.address.vatNumber }}
          </p>
        </template>
      </div>
    </section>
    <hr />
    <section id="document__table" class="document__table">
      <slot name="table"></slot>
      <div class="document__table__below">
        <div>
          <n-button
            v-if="showAddTableRowButton"
            class="document__table__below__add-item-btn"
            type="info"
            round
            @click.native.prevent="$emit('add-table-row-click')"
            >{{ $t("message.addItem") }}</n-button
          >
        </div>
        <div class="document__table__below__totals">
          <table>
            <tr v-if="subTotal">
              <td class="document__table__below__totals__label">
                {{ $t("message.subTotal") }}
              </td>
              <td>{{ subTotal }}</td>
            </tr>
            <tr v-if="vatTotal">
              <td class="document__table__below__totals__label">
                {{ $t("message.vatTotal") }}
              </td>
              <td>{{ vatTotal }}</td>
            </tr>
            <tr v-if="total">
              <td
                class="document__table__below__totals__label document__table__below__totals__label--strong"
              >
                {{ $t("message.total") }}
              </td>
              <td>
                <strong>{{ total }}</strong>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </section>
    <hr />
    <section id="document__terms" class="document__terms">
      <h5 class="document__terms__label">
        <strong>{{ $t("message.terms") }}</strong>
      </h5>
      <textarea
        v-if="editableTerms"
        class="document__terms__textarea"
        :value="terms"
        :placeholder="$t('message.termsPlaceholder')"
        rows="3"
        @change="value => $emit('terms-change', value)"
      ></textarea>
      <p v-else>{{ terms || $t("message.noTerms") }}</p>
    </section>
    <hr />
    <section id="document__notes" class="document__terms">
      <h5 class="document__terms__label">
        <strong>{{ $t("message.notes") }}</strong>
      </h5>
      <textarea
        v-if="editableNotes"
        class="document__terms__textarea"
        :value="notes"
        :placeholder="$t('message.notesPlaceholder')"
        rows="3"
        @change="value => $emit('notes-change', value)"
      ></textarea>
      <p v-else>{{ notes || $t("message.noNotes") }}</p>
    </section>
  </card>
</template>
<script>
import CompanyLogo from "@/components/CompanyLogo";

export default {
  components: {
    CompanyLogo
  },
  props: {
    title: {
      type: String,
      default() {
        return this.$t("message.document");
      }
    },
    headerItems: {
      type: Array,
      default: () => []
    },
    fromLabel: {
      type: String,
      default() {
        return this.$t("message.from");
      }
    },
    from: {
      type: Object,
      default: () => {}
    },
    toLabel: {
      type: String,
      default() {
        return this.$t("message.to");
      }
    },
    to: {
      type: Object,
      default: () => {}
    },
    tableLabel: {
      type: String,
      default: "Items"
    },
    subTotal: {
      type: String,
      default: null
    },
    vatTotal: {
      type: String,
      default: null
    },
    total: {
      type: String,
      default: null
    },
    terms: {
      type: String,
      default: null
    },
    notes: {
      type: String,
      default: null
    },
    showAddTableRowButton: Boolean,
    editableTerms: Boolean,
    editableNotes: Boolean
  }
};
</script>
